import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Routes } from '../../routes';

import TeamLeagueWeeks from './components/TeamLeagueWeeks';
import stylesPlayOff from './PlayOff.module.scss';
import { useStats } from './StatsContext';
import styles from './styles.module.scss';

export const PlayOff = () => {
  const { playoff } = useStats();

  return (
    <>
      <section>
        <header className={styles.headerSimple}>
          <h1 className={clsx(styles.stageHeading)}>Play-off</h1>
        </header>
        <p className={stylesPlayOff.description}>
          4 týmy s nejvyšším počtem bodů ze <Link to={Routes.TL25.routes.GROUP_STAGE.path}>základní části</Link>{' '}
          postoupily do play-off
        </p>
        <div className={stylesPlayOff.rules}>
          <h2 className={styles.heading}>Pravidla</h2>
          <ul className={stylesPlayOff.rulesList}>
            <li>1v1 nejlepší proti nejlepšímu, druhý nejlepší proti druhému nejlepšímu atd.</li>
            <li>
              Kapitáni můžou posunout každého hráče, avšak max. o 1 místo (např. druhého nejlepšího na 1. či 3. místo)
            </li>
            <li>Pokud má tým 7 hráčů, může libovolně nahrazovat slabším hráčem</li>
            <li>
              Mappick
              <ul>
                <li>1. mapu vybírá hráč z týmu, který v základní části skončil výše</li>
                <li>2. mapa loser&apos;s pick</li>
              </ul>
            </li>
            <li>Team melee - kapitáni můžou nasadit 1-4 hráče bez omezení</li>
            <li>V případě remízy se hraje BO3 team melee se stejnými pravidly</li>
          </ul>
        </div>
        <section className={clsx(styles.content, styles.spaceTop, styles.space)}>
          <TeamLeagueWeeks weeks={playoff} />
        </section>
      </section>
      <nav className={clsx(styles.buttonList, styles.navBottom, styles.spaceTop)}>
        <Link to={Routes.TL25.routes.OVERVIEW.path} className={styles.navButton}>
          Přehled
        </Link>
        <Link to={Routes.TL25.routes.GROUP_STAGE.path} className={styles.navButton}>
          Základní část
        </Link>
      </nav>
    </>
  );
};
